<template>
  <div
    style="
      width: 100%;
      height: 100%;
      background: rgb(0, 0, 0, 0.5);
      padding: 40px;
      position: fixed;
      z-index: 9999000;
      top: 0;
      left: 0;
    "
    class="transition-box"
    @contextmenu.prevent.enter="close"
  >
    <div
      :style="{
        height: '100%',
        width: state?.width,
        backgroundColor: '#fff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '0.1px solid #1779de',
        margin: '0 auto',
      }"
      @click.stop=""
      @contextmenu.prevent.stop=""
    >
      <ul
        style="
          height: 30px;
          background-color: #1779de;
          padding: 0 10px;
          font-size: 14px;
          line-height: 30px;
          color: #fff;
          display: flex;
          align-items: center;
        "
      >
        <li style="flex: 1">
          {{ state?.title }}
        </li>
        <li class="closeIcon">
          <el-icon style="color: #fff" size="18" @click="close()"
            ><Close
          /></el-icon>
        </li>
      </ul>
      <ul style="flex: 1; overflow: hidden; width: 100%">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, watch } from "vue";
export default {
  props: {
    title: String,
    width: String,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.title = props.title;
      state.width = props.width || "100%";
    });

    watch(
      () => props.title,
      (value) => {
        state.title = value;
      },
      () => props.width,
      (value) => {
        state.width = value || "100%";
      }
    );

    const close = () => {
      emit("close");
    };

    return { state, close };
  },
};
</script>
<style scoped>
.closeIcon {
  display: flex;
  align-items: center;
}

.closeIcon .el-icon {
  cursor: pointer;
  margin-left: 5px;
}
.closeIcon .el-icon:hover {
  transform: scale(1.3);
}
</style>
